import * as React from 'react';
import { Button, Accordion, AccordionSummary, Grid, Typography, } from '@mui/material';
import IconStart from '@mui/icons-material/Send';
import { useHistory } from 'react-router-dom';
import Routes from 'app/routes/Routes';
import { useSelector } from 'react-redux';
import { makeStyles, withStyles } from '@mui/styles';
import ExpandMoreIcon from '@mui/icons-material/KeyboardArrowDown';
import SavedConsultationItem from 'features/riesterProfiCheck/customers/view/overview/components/detail/SavedConsultationItem';
import { useAppDispatch } from 'app/store';
import { getSavedConsultationsForCurrentUser } from 'features/riesterProfiCheck/consultation/saved_consultations/savedConsultationsSlice';
import { ConsultationActions } from 'features/riesterProfiCheck/consultation/consultationSlice';
import { getCurrentCustomer } from 'features/riesterProfiCheck/customers/customerSlice';
import { Consultation } from 'features/riesterProfiCheck/consultation/models/Consultation';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: '100%'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular
    }
}));

const CustomAccordion = withStyles((theme: Theme) => ({
    root: {
        width: '100%',
        border: 'none',
        '&::before': {
            backgroundColor: 'white'
        }
    }
}))(Accordion)

const CustomerActionsView: React.FC = () => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useAppDispatch();

    const savedConsultations = useSelector(getSavedConsultationsForCurrentUser) as Array<Consultation>;
    const currentCustomer = useSelector(getCurrentCustomer);

    return (
        <Grid container direction={'column'} alignItems={'flex-start'}>
            <Button
                onClick={() => {
                    dispatch(ConsultationActions.startConsultation(currentCustomer?.id));
                    history.push(Routes.Consultation.Questions);
                }}
                variant={'outlined'}
                color={'primary'}
                fullWidth
                startIcon={<IconStart />}
                style={{ marginBottom: '12px' }}
            >
                Beratung starten
            </Button>
            {savedConsultations !== undefined && savedConsultations?.length !== 0 ? (
                <CustomAccordion variant={'outlined'} square>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography className={classes.heading}>Gespeicherte Beratungen</Typography>
                    </AccordionSummary>

                    {savedConsultations?.map((consultation: Consultation) => {
                        return <SavedConsultationItem savedConsultation={consultation} key={consultation.id} />;
                    })}
                </CustomAccordion>
            ) : (
                <div></div>
            )}
        </Grid>
    );
};

export default CustomerActionsView;
